<template>
    <div class="flex md:flex-row flex-col md:gap-5 gap-1">
        <div class="flex items-center gap-2">
            <font-awesome-icon widthAuto class="text-slate-400" :icon="faFaceMeh" />
            <span class="text-sm text-black">unhealthy, performing below goal</span>
        </div>
        <div class="flex items-center gap-2">
            <font-awesome-icon widthAuto class="text-sky-500" :icon="faFaceGrinStars" />
            <span class="text-sm text-black">healthy, performing above goal</span>
        </div>
    </div>
</template>

<script setup>
import { faFaceGrinStars, faFaceMeh } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
</script>
